import { Injectable } from '@angular/core';
import { LoadingController, LoadingOptions, ToastController, ToastOptions } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public loading: HTMLIonLoadingElement = null;

  constructor(public loadingController: LoadingController) {}

  async presentLoading(lo: LoadingOptions) {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }

    this.loading = await this.loadingController.create({
      message: lo.message ? lo.message : 'Default Message',
      duration: lo.duration ? lo.duration : 2000,
      backdropDismiss: lo.backdropDismiss ? lo.backdropDismiss : false,
    });
    this.loading.present();
  }

  dismissLoading() {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }
  }
}
